import React from "react";
import useHover from "../../hooks/useHover";

const BackButton = ({ onClick }) => {
  const hover = useHover();
  return (
    <img
      onClick={onClick}
      {...hover.divProps}
      style={{
        cursor: "pointer",
        opacity: hover.hover ? "100%" : "50%",
      }}
      src={"/icons/icon_back.png"}
      className="icon40"
    />
  );
};

export default BackButton;
